import type { Task } from '../../services/api/tasksService';
import { isAtRisk, isBlocked, isLate } from './LookAheadSummaryTiles';

export const hasScheduleDates = (task: Task): boolean => Boolean(task.startDate && task.dueDate);

export const healthForLookAheadTask = (task: Task) => {
  if (!hasScheduleDates(task)) return { label: 'Needs dates', color: 'default' as const };
  if (isBlocked(task)) return { label: 'Blocked', color: 'error' as const };
  if (isLate(task)) return { label: 'Late', color: 'error' as const };
  if (isAtRisk(task)) return { label: 'At risk', color: 'warning' as const };
  return { label: 'On track', color: 'success' as const };
};
